function loader() {
	var elem = document.getElementById("myBar");
	var elem2 = document.getElementById("myBar2");
	var prog = document.getElementById("myProgress");
	var prog2 = document.getElementById("myProgress2");
	var width = 1;
	var width2 = 1;
	var id = setInterval(frame, 30);
	function frame() {
		if (width >= 100) {
		clearInterval(id);
		if (width == 100) {
			prog.style.display = "none";
		}
		} else {
		width++;
		elem.style.width = width + "%";
		}
		if (width2 >= 100) {
		clearInterval(id);
		if (width2 == 100) {
			prog2.style.display = "none";
		}
		} else {
		width2++;
		elem2.style.width = width2 + "%";
		}
	}
}

$(function(){
   	$(".menu-item").click(function(){
   		$(this).toggleClass("active");
      	$(this).find("ul.submenu").slideToggle();
   	});

	setTimeout(function () {
	$('#dl-menu').dlmenu();
	}, 5000);

    if ($(window).width() > 992) {
      $('ul.dl-menu').addClass('dl-menuopen');
    } else {
      $('ul.dl-menu').removeClass('dl-menuopen');
    } 


    window.onload = function move() {
      loader();
    } 

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      //>=, not <= 
      if (scroll >= 200) {
        //clearHeader, not clearheader - caps H 
        $(".dl-menuwrapper").addClass("fixed-menu");
      } else {
        $(".dl-menuwrapper").removeClass("fixed-menu");
      }
    }); //missing ); 

	$(".menu-item").click(function () {
		$(this).toggleClass("active");
		$(this).find("ul.submenu").slideToggle();
	});


});


//////////////////
// WEBPACK FOOTER
// ./static/js/scripts.js
// module id = 9xGY
// module chunks = 1